<template>
	<DsAccordionItem class="c-faq-item" :title="title" :icon-name="dsFaqIcon">
		<div
			v-if="!!props.description?.trim()"
			class="c-faq-item__description"
			v-html="description"
		></div>
	</DsAccordionItem>
</template>

<script setup lang="ts">
import { DsAccordionItem } from '@coloplast/design-system';
import type { IconName } from '@coloplast/design-system/dist/types/components/icon/interface.d.ts';

export type FaqAlignmentTextOption = 'Before' | 'After';

export interface FaqItem {
	/** FAQ title text */
	title: string;
	/** Raw HTML string for the description/answer */
	description?: string | null;
	/** Name for <ds-icon> (when provided, takes precedence over faqIconSrc) */
	dsFaqIcon?: IconName | null;
}

const props = withDefaults(defineProps<FaqItem>(), {
	description: null,
	dsFaqIcon: null,
	faqIconSrc: null,
	imageSrc: null,
	imageAlt: '',
	videoSrc: null,
	alignmentTextOption: 'Before' as FaqAlignmentTextOption,
	placeholderSrc: null,
});
</script>

<style lang="scss">
	.c-faq-item__description p:last-child {
		margin-block-end: 0;
	}
</style>
